(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

customProfession = {
    prof_uid: false,
    otherOpen: false,
    oldSelect: false,
    selectParent: false,
    rowType: false,
    userID: false,
    currentProfessions: [],
    newContent: false,
    realSelect: false,
    isEdit: false
};
function getDepProf(callback) {
    callback = typeof callback === 'undefined' ? function () {} : callback;
    $.getJSON('/api/v1/professions', function (data) {
        professions = data.professions;
        departments = data.departments;
        callback();
    });
}

function deleteCustomProfession(event, element) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false;
    event.stopPropagation ? event.stopPropagation() : event.returnValue = false;
    var valueProf = $(element).parent().attr('rel');
    var profIndex = $(element).parent().parent().attr('data-index');
    $('body').append('<div class="overlay"></div>');
    $('#deleteProfession').empty().html('Are you sure you want to delete the profession: ' + $(element).closest('li').text());
    $('#deleteProfession').dialog({
        height: 140,
        draggable: false,
        resizable: false,
        appendTo: 'body',
        close: function close(event, ui) {
            $('.overlay').remove();
        },
        buttons: {
            No: function No() {
                $(this).dialog("close");
                $(this).dialog("destroy");
                return false;
            },
            Yes: function Yes() {
                $.post('/api/v1/professions/' + valueProf, { '_method': 'delete' }, function (data) {
                    $('.usr_prof option[value="' + valueProf + '"]').remove();
                    getDepProf(function () {
                        $('.usr_prof').selectric('refresh');
                    });
                    if (data.error) {
                        popUpMsg('Please enter a start date that is before the selected end date.');
                    }
                }, 'json');
                $('.selectric-group').find('li[data-index="' + profIndex + '"]').remove();
                if ($('.usr_prof').val() == valueProf) {
                    $('.usr_prof').val(0);
                    $('.selectric p').text('Choose Profession');
                }
                $(this).dialog("close");
                $(this).dialog("destroy");
            }
        }
    });
    $('.ui-dialog-buttonset button, .ui-dialog-buttonset button > span').removeClass().attr('role', '').attr('aria-disabled', '');
};

function showEditCustomProfession(event, element) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false;
    buildProfessionDepartment();
    if (customProfession.isEdit) {
        customProfession.isEdit = true;
        customProfession.realSelect = $(element).closest('.selectric-items').siblings('.selectric-hide-select').children('.usr_prof');
        customProfession.selectParent = $(element).closest('.dash_cell');
        customProfession.oldSelect = $(customProfession.selectParent).children();
        customProfession.rowType = $(element).closest('.indicator_row').data('user-type');
        customProfession.userID = $(element).closest('.indicator_row').attr('rel');
        customProfession.prof_uid = $(element).parent().attr('rel');
        $(customProfession.realSelect).find('option[value="' + customProfession.prof_uid + '"]').prop('selected', true);
        $('.usr_prof').selectric('refresh');
        $(customProfession.realSelect).change();
    }
    customProfession.otherOpen = true;
    var input = '<input type="text" id="prof_custom" name="prof_custom" data-index="' + $(element).parent().parent().attr('data-index') + '" value="' + (customProfession.isEdit ? professions[customProfession.prof_uid].title : '') + '" placeholder="Enter Profession">';
    var helper = '<div class="defPop" id="other_profession_pop"><div class="onlyRelWrap"><span class="pop-content"><p style="font-weight: bold; font-size: 16px;">Enter Profession name</p><br><p class="text-center"><button id="cancel_custom_profession" class="button-style-2 btn-xs">Cancel</button> <button id="save_custom_profession" class="button-style-2 btn-xs">Save</button></p><span id="error_message"></span></span></div></div>';
    $(customProfession.oldSelect).hide();
    customProfession.newContent = $(input + helper).appendTo(customProfession.selectParent);
    $('#prof_custom').focus();
    $('#other_profession_pop').css({
        left: '0',
        width: '100%',
        bottom: '33px',
        top: 'auto',
        'z-index': '999999',
        'box-sizing': 'border-box'
    });
    $('#other_profession_pop').css('display', 'block').stop().animate({
        'opacity': 1
    }, 300);
    if (customProfession.isEdit) {
        $(customProfession.selectParent).nextAll().children('table').removeClass('indMonthTable').addClass('customProfessionCategory');
    } else {
        $(customProfession.selectParent).nextAll().children('table').removeClass('indMonthTable').addClass('customProfessionCategory').find('td').removeClass().addClass('auto-style517');
    }
    return false;
}

function buildProfessionDepartment() {
    var departmentsFormatted = {};
    $.each(departments, function (index, department) {
        department.professions = [];
        departmentsFormatted[department.uid] = department;
    });
    $.each(professions, function (prof_uid, profession) {
        $.each(departmentsFormatted, function (dep_uid, department) {
            if ($.inArray(dep_uid, profession.default_departments) != -1) {
                departmentsFormatted[dep_uid].professions.push(profession.title);
            }
        });
        customProfession.currentProfessions.push(profession.title.toLowerCase());
    });
}
$(document).ready(function () {
    if (demo || !demo && adminPrivilages) {
        $('.indMonthTable').click(setIndicatorCategory);
    }
    $('.hover').hover(function () {
        var that = $(this);
        var right = $(that).parent().width() - $('.c').position().left - 5;
        $('#member_type_hover').css({ left: 'auto', right: right + 'px', width: 'auto', bottom: '-10px', top: 'auto', 'z-index': '999999', 'border-color': $(that).data('border') });
        $('#member_type_hover').css('display', 'block').stop().animate({ 'opacity': 1 }, 300);
        $('#member_type_hover').find('.pop-content').empty().html($(that).data('content'));
    }, function () {
        $('#member_type_hover').stop().animate({ 'opacity': 0 }, 300, function () {
            $(this).css('display', 'none');
        });
    });

    $('.topRight, .indicator_desc_close').click(function () {
        $(this).parent().parent().stop().animate({ 'opacity': 0 }, 300, function () {
            $(this).css('display', 'none');
        });
    });

    if (navigator.userAgent.match(/iPhone/i)) {

        $('#manage_users_key li').css('font-size', '10px');
    }

    $('#dep_uid').change(function () {
        if ($(this).val() != '') window.location.href = '/facility/indicators/' + $(this).val();
    });

    $('.deleteUser').click(function () {
        if (!adminPrivilages && !demo) {
            popUpMsg('Only committee chairpersons can delete a user.');
            return false;
        } else if (demo) {
            needsToRegisterError('modify users.');
            return false;
        }

        var delete_usr_uid = $(this).attr('rel'),
            usr_name = $(this).attr('data-full-name'),
            memberType = $('#ind_row_' + $('.usr_uid-' + $(this).attr('rel')).val()).attr('data-user-type');
        popUpConfMsg('Are you sure you want to delete ' + usr_name + '?', function () {
            var postData = {
                ss: memberType == 'support' ? 1 : 0,
                _method: 'delete'
            };
            $.ajax({
                url: '/facility/members/manage-users/' + delete_usr_uid,
                data: postData,
                method: 'POST'
            }).fail(function (data, status, xhr) {
                if (data == 'Unauthorized' || xhr.status == 401) {
                    demo = true;
                    needsToRegisterError('make changes to member departments.');
                } else if (data == 'Forbidden' || xhr.status == 403) {
                    popUpMsg('Please contact your Committee Chairperson or Administrator to make changes to departments.');
                } else {
                    unknownError();
                }
            }).done(function (data, status, xhr) {
                window.location.reload();
            });
        });
    });

    $('.users-row input').focusin(function () {
        if (!demo && !adminPrivilages && $('.users-row').attr('rel') != curr_usr_id) {
            popUpMsg('Only committee chairpersons can change other members accounts.');
            return false;
        }
    });

    $('.usr_prof').selectric({
        arrowButtonMarkup: '<img src="/assets/images/Down-Arrow-Gray.png"/>',
        disableOnMobile: false,
        optionsItemBuilder: function optionsItemBuilder(itemData, element, index) {
            if ($(itemData.element).attr('rel') == 'custom' && adminPrivilages) {
                return '<span>' + $(itemData.element).text() + '</span>' + '<div class="option-buttons" rel="' + $(itemData.element).val() + '"><a href="#" class="edit_link"><i class="icon-pencil" data-icon="k"></i></a> <a href="#" class="delete_link"><i class="icon-trash-can" data-icon="T"></i></a></div>';
            } else {
                return '<span>' + $(itemData.element).text() + '</span>';
            }
        },
        onOpen: function onOpen() {
            $('.option-buttons, li a').unbind('click');
            $('.edit_link').click(function () {
                customProfession.isEdit = true;
                showEditCustomProfession(event, this);
            });
            $('.delete_link').click(function () {
                deleteCustomProfession(event, this);
            });
            if (!demo && !adminPrivilages && $('.users-row').attr('rel') != curr_usr_id) {
                popUpMsg('Only committee chairpersons can change other members accounts.');
                return false;
            }
        }
    });
    getDepProf();
    $('.usr_prof').on('change', function () {
        var selectedProfession = $(this);
        if ($(selectedProfession).val() != '0' && $(selectedProfession).val() != 'other') {
            $(this).removeClass('blank');
            if (adminPrivilages) {
                var selectedDefault = professions[$(selectedProfession).val()];
                var closestIndicators = $(this).closest('.dash_cell').siblings('.dash_cell').find('table');
                $(closestIndicators).find('td').removeClass();
                $.each(selectedDefault.default_departments, function (index, value) {
                    var thisIndicatorTD = $(closestIndicators).find('td[rel="' + value + '"]');
                    var defaultPermission = selectedDefault.default_permissions[index];
                    if (defaultPermission == '3') {
                        $(thisIndicatorTD).addClass('auto-style552');
                    } else if (defaultPermission == '2') {
                        $(thisIndicatorTD).addClass('auto-styleAlert');
                    }
                });
                var AllIndicatorsTD = $(closestIndicators).find('td');
                //set default classes
                $.each(AllIndicatorsTD, function (index, element) {
                    if (!$(element).hasClass('auto-style552') && !$(element).hasClass('auto-styleAlert')) {
                        $(element).addClass('auto-style517');
                    }
                });
            }
            //console.log($(selectedProfession).val());
            // if (!($(selectedProfession).val() == 'other')) {
            //     var userType = $(this).closest('.users-row').data('user-type');
            //     updateUser($(this).attr('rel'), false, userType);
            // }
        }
        if ($(selectedProfession).val() == 'other') {
            customProfession.realSelect = $(this);
            customProfession.selectParent = $(this).closest('.dash_cell');
            customProfession.oldSelect = $(customProfession.selectParent).children();
            customProfession.rowType = $(this).closest('.indicator_row').data('user-type');
            customProfession.userID = $(this).closest('.indicator_row').attr('rel');
            showEditCustomProfession($(this));
        }
    });

    function removeCustomProfessionContent() {
        $('#other_profession_pop').css('display', 'block').stop().animate({
            'opacity': 0
        }, 300, function () {
            $(customProfession.newContent).remove();
            $(customProfession.oldSelect).show();
            $(customProfession.selectParent).nextAll().children('table').removeClass('customProfessionCategory').addClass('indMonthTable');
            customProfession.otherOpen = false;
            customProfession.prof_uid = false;
            customProfession.oldSelect = false;
            customProfession.selectParent = false;
            customProfession.rowType = false;
            customProfession.userID = false;
            customProfession.newContent = false;
            customProfession.realSelect = false;
            customProfession.isEdit = false;
        });
    }
    $(document).on('click', '#cancel_custom_profession', function (e) {
        e.preventDefault();
        removeCustomProfessionContent();
        $(customProfession.realSelect).find('option[value="0"]').prop('selected', true);
        $('.usr_prof').selectric('refresh');
        return false;
    });
    $(document).on('click', '#save_custom_profession', function (e) {
        e.preventDefault();
        if (demo) {
            popUpMsg('To update your profile please <a href="/register">register</a>.');
            return false;
        }
        $('#error_message').empty();
        if (!customProfession.isEdit) {
            if ($.inArray($('#prof_custom').val().toLowerCase(), customProfession.currentProfessions) != -1) {
                $('#other_profession_pop .pop-content #error_message').append('<br>That profession already exists.');
                return;
            }
        }
        if ($('#prof_custom').val() == '') {
            $('#other_profession_pop .pop-content #error_message').append('<br>You must enter a profession title.');
            return;
        }
        $('#other_profession_pop').closest('#table_header').find('.updateAllUsers').click();
        var newProfTitle = $('#prof_custom').val();
        var postData = {
            usr_uid: customProfession.userID,
            title: newProfTitle
        };
        var index = $('#prof_custom').attr('data-index');
        if (customProfession.isEdit) {
            postData['_method'] = 'put';
        }
        $.post('/api/v1/professions' + (customProfession.isEdit ? '/' + customProfession.prof_uid : ''), postData, function (data) {
            if (!customProfession.isEdit) {
                $('optgroup').append('<option value="' + data.id + '" rel="custom">' + $('#prof_custom').val() + '</option>');
            } else {
                var currentTitle = professions[customProfession.prof_uid].title;
                professions[customProfession.prof_uid].title = newProfTitle;
                $('optgroup').find('option[value="' + customProfession.prof_uid + '"]').text(newProfTitle);
                $('.selectric p').each(function () {
                    if ($(this).text() == currentTitle) $(this).text(newProfTitle);
                });
                $('.selectric-group li[data-index="' + parseInt(index) + '"]').find('span').text(newProfTitle);
            }
            $('.usr_prof').selectric('refresh');
            $(customProfession.realSelect).find('option').prop('selected', false);
            $(customProfession.realSelect).find('option[value="' + data.id + '"]').prop('selected', true);
            removeCustomProfessionContent();
            customProfession.otherOpen = false;
            $(customProfession.newContent).remove();
            $(customProfession.oldSelect).show();
            getDepProf(function () {
                if (!customProfession.isEdit) $('.usr_prof').selectric('refresh');
                $(customProfession.realSelect).trigger('change');
            });
            if (data.error) {
                popUpMsg('Failed to load professions.');
            }
        }, 'json');
        return false;
    });
    $('.updateUser').click(function (e) {
        e.preventDefault();
        var userType = $('.users-row').data('user-type');
        if (demo) {
            needsToRegisterError('update users.');
            return false;
        }
        if (!$('#ind_row_account').valid()) {
            return false;
        }
        $.each($('.users-row[data-user-type="' + userType + '"]'), function (index, element) {
            if (!adminPrivilages) {
                if ($(this).attr('rel') != curr_usr_id) {
                    return true;
                }
            }
            updateUser($(this).attr('rel'), false, userType);
        });
    });

    function splitArray(a, n) {
        var len = a.length,
            out = [],
            i = 0;
        while (i < len) {
            var size = Math.ceil((len - i) / n--);
            out.push(a.slice(i, i += size));
        }
        return out;
    }
    $('.indicator-category-title').click(function (e) {
        e.preventDefault();
        buildProfessionDepartment();
        if ($(this).data('open') == 'false' || typeof $(this).data('open') === 'undefined') {
            $('.indicator-category-title').data('open', 'false');
            $('.indicator-category-professions-div').animate({
                opacity: 0
            }, 300, function () {
                $(this).remove();
            });
            $(this).parent().css('position', 'relative');
            var html = '<div class="indicator-category-professions-div ' + ($(this).hasClass('title-top') ? 'title-top' : '') + '">';
            html += '<p style="position: relative;"><strong>' + departmentsFormatted[$(this).attr('rel')].name + '</strong><span style="display: block; position: absolute; right: 10px; top: 6px;"><i class="icon-cancel-circled" data-icon="i" style="font-size: 20px;"></i></span></p>';
            departmentsFormatted[$(this).attr('rel')].professions.sort();
            var columnsFormatted = splitArray(departmentsFormatted[$(this).attr('rel')].professions, 3);
            for (var c = 0; c < columnsFormatted.length; c++) {
                html += '<ul class="align_left" style="display: inline-block; width: 33%;margin: 0px auto;">';
                for (var i = 0; i < columnsFormatted[c].length; i++) {
                    html += '<li style="font-size: 12px; margin: 10px 0;">' + columnsFormatted[c][i] + '</li>';
                }
                html += '</ul>';
            }
            html += '</div>';
            $(html).css('opacity', '0').appendTo(this).animate({
                opacity: 1
            }, 200);
            $(this).data('open', 'true');
        } else if ($(this).data('open') == 'true') {
            $('.indicator-category-title').data('open', 'false');
            $('.indicator-category-professions-div').animate({
                opacity: 0
            }, 200, function () {
                $(this).remove();
            });
        }
    });
    $('.users-row').tooltipster({
        trigger: 'custom',
        onlyOne: true,
        animation: 'grow',
        position: 'bottom'
    });
    $.validator.addMethod("valueNotEquals", function (value, element, arg) {
        if ($(element).closest('.users-row').attr('id') != 'ind_row_NEW') return true;
        return arg != value;
    }, "Value must not equal arg.");
    createValidatorRow('#users-form', false);
    createValidatorRow('#support-form', false);
    createValidatorRow('#ind_row_NEW[data-user-type="users"]', true);
    createValidatorRow('#ind_row_NEW[data-user-type="support"]', true);

    function createValidatorRow(element, password) {
        var validator = $(element).validate({
            ignore: [],
            rules: {
                usr_fname: 'required',
                usr_lname: 'required',
                usr_email: {
                    required: true,
                    email: true
                },
                usr_password: {
                    required: password
                },
                usr_prof: {
                    valueNotEquals: "0"
                }
            },
            success: function success(label, element) {
                if (validator.numberOfInvalids() == 0) {
                    $(element).closest('.users-row').tooltipster('hide');
                }
            },
            errorPlacement: function errorPlacement(error, element) {
                if ($(error).text() != '') {
                    $(element).closest('.users-row').tooltipster('update', 'All fields are required');
                    $(element).closest('.users-row').tooltipster('show');
                }
            }
        });
    }
});

function setIndicatorCategory() {
    if (customProfession.otherOpen) {
        return;
    }
    var committees = new Array(),
        perms = new Array(),
        i = 0,
        ind_uid = $(this).attr('rel'),
        thisChildTD = $(this).children('tbody').children('tr').children('td');
    if (!adminPrivilages && !demo) {
        popUpMsg('Only committee chairpersons can set indicator categories.');
        return false;
    }
    if ($(thisChildTD).hasClass('auto-style552')) {
        $(thisChildTD).removeClass('auto-style552').addClass('auto-styleAlert');
    } else if ($(thisChildTD).hasClass('auto-styleAlert')) {
        $(thisChildTD).removeClass('auto-styleAlert').addClass('auto-style517');
    } else {
        $(thisChildTD).removeClass('auto-style517').addClass('auto-style552');
    }
    $('.indMonthTable[rel="' + ind_uid + '"] td, .customProfessionCategory[rel="' + ind_uid + '"] td').each(function () {
        if ($(this).hasClass('auto-style552') || $(this).hasClass('auto-styleAlert') || $(this).hasClass('auto-styleBlue')) {
            val = Number($(this).attr('rel'));
            committees[i] = val;
            if ($(this).hasClass('auto-styleAlert')) {
                perms[i] = 2;
            } else if ($(this).hasClass('auto-styleBlue')) {
                perms[i] = 4;
            } else {
                perms[i] = 3;
            }
            i++;
        }
    });
    if (ind_uid != 'NEW' && !demo) {
        var memberType = $('#ind_row_' + $('.usr_uid-' + ind_uid).val()).attr('data-user-type');
        var thisUserID = $('.usr_uid-' + ind_uid).val();
        console.log("HERE");
        if (thisUserID == '') {
            unknownError();
            return;
        }
        var postData = {
            departments: committees,
            privs: perms,
            ss: memberType == 'support' ? 1 : 0,
            _method: 'put'
        };
        $.ajax({
            url: '/facility/members/manage-users/departments/' + thisUserID,
            data: postData,
            method: 'POST'
        }).fail(function (data, status, xhr) {
            if (xhr == 'Unauthorized') {
                demo = true;
                needsToRegisterError('make changes to member departments.');
            } else if (xhr == 'Forbidden') {
                popUpMsg('Please contact your Committee Chairperson or Administrator to make changes to departments.');
            } else if (xhr == "Unprocessable Entity") {
                popUpMsg('Your password must be at least 6 characters and contain one number');
            } else {
                unknownError();
            }
        });
    }
}

function updateUser(rowID, showMessage, user_type) {
    if (demo) {
        return false;
    }
    showMessage = typeof showMessage !== 'undefined' ? showMessage : true;

    var firstName = $('#ind_row_' + rowID + ' .usr_fname').val(),
        lastName = $('#ind_row_' + rowID + ' .usr_lname').val(),
        email = $('#ind_row_' + rowID + ' .usr_email').val(),
        profession = $('#ind_row_' + rowID + ' .usr_prof :selected').val(),
        license = $('#ind_row_' + rowID + ' .usr_license').val(),
        committees = [],
        perms = [],
        i = 0;

    if (firstName == '' || email == '' || lastName == '') {
        return false;
    }

    if (rowID === 'NEW' && $('#ind_row_' + rowID + ' .usr_password').val() == '') {
        popUpMsg('A password is required.');
        return false;
    }

    $('.users-row[data-user-type="' + user_type + '"] .indMonthTable[rel="' + rowID + '"] td').each(function () {
        if ($(this).hasClass('auto-style552') || $(this).hasClass('auto-styleAlert') || $(this).hasClass('auto-styleBlue')) {
            val = $(this).attr('rel');
            committees[i] = val;
            if ($(this).hasClass('auto-styleAlert')) {
                perms[i] = 2;
            } else if ($(this).hasClass('auto-styleBlue')) {
                perms[i] = 4;
            } else {
                perms[i] = 3;
            }
            i++;
        }
    });

    $('#ind_row_' + rowID + ' input.error').removeClass('error');

    var postData = {
        first_name: firstName,
        last_name: lastName,
        email: email,
        prof_uid: profession,
        is_surveyor: is_surveyor,
        license: $('#ind_row_' + rowID + ' .usr_license').val()
    };
    console.log(postData);
    var passVal = $('#ind_row_' + rowID + ' .usr_password').val();
    if (rowID !== 'NEW') {
        postData['_method'] = 'put';
    }
    if (passVal != '') {
        postData['password'] = passVal;
    }
    $.ajax({
        url: '/facility/members/manage-users/' + rowID,
        data: postData,
        method: 'PUT'
    }).fail(function (data, status, xhr) {
        if (xhr == 'Unauthorized') {
            demo = true;
            needsToRegisterError('edit members.');
        } else if (xhr == 'Forbidden') {
            popUpMsg('Please contact your Committee Chairperson or Administrator to make changes to members.');
        } else if (xhr == "Unprocessable Entity") {
            popUpMsg('Your password must be at least 6 characters and contain one number');
        } else {
            unknownError();
        }
    }).always(function (data, status, xhr) {
        if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== "object") {
            $('#ind_row_' + rowID + ' .usr_password').val('');
        } else {
            var namesToActualElements = { first_name: 'usr_fname', last_name: 'usr_lname', email: 'usr_email', password: 'usr_password' };
            var errors = data.responseText;
            // var errorKeys = Object.keys(errors);
            // for(var i = 0; i < errorKeys.length; i++){
            // 	$('#ind_row_' + rowID + ' input[name="'+namesToActualElements[errorKeys[i]]+'"]').addClass('error');
            // }
        }
        if (status === 'success') {
            popUpMsg('Update Complete');
            setTimeout(function () {
                window.location.reload();
            }, 1500);
        }
    });
}

},{}]},{},[1]);
